// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes YFzLnvZ1CGLqG4 {
  0% {
    width: 12px;
  }
  100% {
    width: 0px;
  }
}
.WEpG5lolDqudqK {
  padding: var(--ds-space-0, 0);
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb {
  position: relative;
  width: 12px;
  height: 100%;
  background: transparent;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb::after {
  content: '';
  position: absolute;
  top: 50%;
  left: var(--ds-space-075, 5px);
  width: 2px;
  height: 20px;
  margin-top: var(--ds-space-negative-150, -10px);
  border-radius: var(--ds-border-radius-050, 2px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
@media (prefers-reduced-motion) {
  .WEpG5lolDqudqK .Vg7i3CAIo0Jxtb {
    animation: unset;
  }
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.JSkUQgjsgFlzUt {
  animation: 0.1s 0.2s forwards YFzLnvZ1CGLqG4;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.JSkUQgjsgFlzUt:hover,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.JSkUQgjsgFlzUt:focus {
  cursor: pointer;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.JSkUQgjsgFlzUt::after,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.JSkUQgjsgFlzUt::before {
  width: 0px;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:hover,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:focus,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.mGf67l7E9bcd6O {
  cursor: ew-resize;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:hover::after,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:focus::after,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.mGf67l7E9bcd6O::after {
  display: none;
}
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:hover::before,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb:focus::before,
.WEpG5lolDqudqK .Vg7i3CAIo0Jxtb.mGf67l7E9bcd6O::before {
  content: '';
  position: absolute;
  top: var(--ds-space-050, 4px);
  bottom: var(--ds-space-050, 4px);
  left: var(--ds-space-075, 5px);
  width: 2px;
  background-color: var(--ds-background-accent-blue-subtler-pressed, #579dff);
}
`, ""]);
// Exports
export var dragAndDropDividerContainer = `WEpG5lolDqudqK`;
export var dragAndDropDivider = `Vg7i3CAIo0Jxtb`;
export var hidden = `JSkUQgjsgFlzUt`;
export var dividerAnim = `YFzLnvZ1CGLqG4`;
export var dragging = `mGf67l7E9bcd6O`;
export default ___CSS_LOADER_EXPORT___;
